export default __webpack_public_path__ + "static/media/offer2.6ac195ce.png";